/**
 * 操作权限处理
 */

import store from '@/store'
import Vue from 'vue'

const hasPermi = Vue.directive('hasPermi', {
  inserted: function (el, binding) {
    const {value} = binding;
    store.dispatch("getPermissionsList").then((res) => {
        const permissions = res;
        if (value && value instanceof Array && value.length > 0) {
            const permissionFlag = value[0];
            const hasPermissions = permissions.includes(permissionFlag)
            if (!hasPermissions) {
                el.parentNode && el.parentNode.removeChild(el)
            }else {
            }
        } else {
            throw new Error(`请设置操作权限标签值`)
        }
    });
  }
});

export { hasPermi }
